import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor() { }

  public mobileDisplayLogoToolbar = new Subject<boolean>();
  public howItWorksDisplay = new Subject<boolean>();
  public howItWorksHide = () => this.howItWorksDisplay.next(false);
  public howItWorksShow = () => this.howItWorksDisplay.next(true);

  public prefillContact = new Subject<any>();
  public prefillContactSet = (data: any) => this.prefillContact.next(data);
}
